<template>
  <div
    v-if="selectInternalStatuses"
    class="d-flex align-items-center justify-content-start mb-1"
  >
    <v-select
      v-if="!dataLoad"
      v-model="showInternalStatuses"
      class="w-100"
      :options="internalStatuses"
      placeholder="Select Internal Statuses"
      label="text"
      multiple
      :searchable="true"
      :clearable="true"
      @input="handleInternalStatuses"
    />
  </div>
</template>

<script>
import VSelect from 'vue-select'

export default {
  components: {
    'v-select': VSelect,
  },
  props: {
    selectInternalStatuses: {
      type: Boolean,
      default: () => false,
    },
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    internalStatuses: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showInternalStatuses: '',
    }
  },
  methods: {
    handleInternalStatuses() {
      this.$router.push({
        query: { ...this.$route.query, internal_status: this.showInternalStatuses },
      })
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
